import Err from '@leverege/error'

import { Resource, Resources } from './rsrc/index.js'
import { getId } from '../Utils.js'

export default function UserApi( api, user ) {
  
  let path = null
  if ( user ) {
    if ( typeof user === 'string' ) {
      path = user
    } else if ( typeof user === 'object' && typeof user.id === 'string' ) {
      path = user.id
    } 
  }

  if ( path == null ) {
    throw Err( `invalid user given to api:${JSON.stringify( user )}` )
  }
  const connect = api.users().child( path )

  function getByUsername( options ) {
    return api.child( `v1/username/${path}` ).get( options )
  }

  function child( path ) {
    return connect.child( path )
  }

  function systems() {
    return connect.child( 'system' ).get()
  }

  function devices( options ) {
    return connect.child( 'device' ).get( options )
  }

  function changePassword( oldPassword, newPassword ) {
    return connect.child( 'changePassword' ).post( { oldPassword, newPassword } )
  }

  function generateTwoFactorCode( method ) {
    return connect.child( `twoFactor/${method}/generateCode` ).post()
  }

  function preActivateTwoFactorMethod( method, data ) {
    return connect.child( `twoFactor/${method}/preActivate` ).post( { ...data } )
  }

  function activateTwoFactorMethod( method, code ) {
    return connect
      .child( `twoFactor/${method}/activate` )
      .post( { code } )
      .then( ( res ) => {
        if ( api.options.storeToken && localStorage ) {
          api.setToken( res.idToken )
        }
        return res
      } )
  }

  function deactivateTwoFactorMethod( method, data ) {
    return connect.child( `twoFactor/${method}/deactivate` ).post( { ...data } )
  }

  function deactivateTwoFactor( data ) {
    return connect.child( 'twoFactor/deactivate' ).post( { ...data } )
  }

  function getOneTimeLoginCodes( password ) {
    return connect.child( 'twoFactor/oneTimeCodes' ).post( { password } )
  }

  function regenerateOneTimeLoginCodes( password ) {
    return connect.child( 'twoFactor/replaceOneTimeCodes' ).post( { password } )
  }

  function refreshTokens() {
    return {
      list : options => connect.child( 'v1/refreshToken' ).get( options ),
    }
  }

  function refreshToken( rt ) {
    const id = getId( rt )
    return {
      get : options => connect.child( `v1/refreshToken/${id}` ).get( options ),
      revoke : ( data, options ) => connect.child( `v1/refreshToken/${id}/revoke` ).patch( data, options ),
    }
  }

  return {
    get : connect.get,
    getByUsername,
    update : connect.patch, 
    delete : connect.delete,
    systems,
    devices,
    changePassword,
    child,
    resource( rsrc ) { return new Resource( connect, rsrc ) },
    resources() { return new Resources( connect ) },
    generateTwoFactorCode,
    preActivateTwoFactorMethod,
    activateTwoFactorMethod,
    deactivateTwoFactorMethod,
    deactivateTwoFactor,
    getOneTimeLoginCodes,
    regenerateOneTimeLoginCodes,
    refreshToken,
    refreshTokens
  }
}
